import { render, staticRenderFns } from "./TkNestedRadio.vue?vue&type=template&id=15c7c03a&"
import script from "./TkNestedRadio.vue?vue&type=script&lang=js&"
export * from "./TkNestedRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports